<script>
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Solicitud Copia',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {  
      exitoso:null ,  
      title: 'Solicitud Copia',
      data : null,    
      fields: [
        { key: 'fechaRegistro', sortable: true,label:"Fecha Registro" },
        { key: 'fechaModificacion', sortable: true,  label:"Fecha Modificación" },
        { key: 'folioSolicitud',soportable:true,label:"Folio Solicitud"},
        { key: 'estatus', soportable:true , label: "Estatus"},
        { key: 'nombreDocumento', soportable:true, label:"Nombre Documento"},
        { key: 'usuario',soportable:true,label:"Usuario Solicitante"},
        { key: 'idSolicitud', sortable: false,  label:"" },
        
      ],
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      totalRows: 0,
      isBusy: false,
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Solicitud Copia',
          active: true,
        },
      ]
    }
  },
  computed:{
  
  },
  mounted(){
    this.exitoso = this.$route.params.exito;
   
  },
   methods:{

     cargarListado(ctx){
       this.isBusy = true;

       let promise =  axios
            .get(appConfig.recursosApi.solicitudCopia,{params: ctx  });

            return promise.then((response) => {
                this.data = response.data.result;
                this.totalRows = response.data.totalRegistros;
                this.isBusy = false;                
                return this.data
            })
             .catch(()=>  {
               this.isBusy = false;
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
                return [];
            }); 
     }

   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
             <b-alert v-if="exitoso"
            show
            dismissible
            class="bg-success text-white border-0"
          >Se ha guardado la información de la solicitud.</b-alert>
            <div class="row"> 
                <div class="col-8">
                       <h4 class="header-title">Solicitud de Copia</h4>
                        <p class="text-muted font-13 mb-4"></p>
                </div>
                <div class="col-4">
                 
                </div>
            </div>
      
            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp; registros
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                   <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                 :busy.sync="isBusy"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :items="cargarListado"
              :fields="fields"
                responsive="sm"
                
              >
              <template v-slot:table-busy>
                 <div class="text-center text-success ">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Cargando...</strong>
                </div>
              </template>
              
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                            <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
                   
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>